import { useAuth } from '@/context/AuthContext'
import { adminRoles } from '@/helpers/roles'
import { accountsRequest } from './centralAuth'
import { useSharing, type SharingRequest } from '@/components/integrations/sharingStore'
export const sharingRequest: SharingRequest = (path, body) => accountsRequest(path, body === undefined ? 'GET' : 'POST', body)
export function useCrmSharing() {
  const { session, isDemo } = useAuth(); const allowed = !isDemo && !!session?.role && adminRoles.includes(session.role)
  const businessKey = allowed ? session?.businessId ?? '' : '', actorKey = session?.userId ?? ''
  return { ...useSharing(sharingRequest, 'CRM', businessKey, actorKey), businessKey, actorKey }
}
